export default __webpack_public_path__ + "static/media/Highlord's Band of Swirling Mist.ace705be.jpg";